import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  AgrChipsFilterModule,
  AgrFilterModule,
  AgrNotificationEmptyModule,
  AgrPageDetailModule,
  AgrPageToolbarModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { ProductOverviewComponent } from './components/product-overview/product-overview.component';
import { ProductComponent } from './product.component';
import { ProductOverviewResolver } from './resolvers/product-overview.resolver';
import { ProductEffects } from './store/effects/product.effects';
import * as productReducer from './store/reducers/product.reducer';

@NgModule({
  declarations: [ProductComponent, ProductOverviewComponent, ProductDetailComponent],
  imports: [
    CommonModule,
    SharedModule,
    AgrFormModule,
    AgrPageDetailModule,
    AgrPageToolbarModule,
    AgrNotificationEmptyModule,
    AgrChipsFilterModule,
    MatFormFieldModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatSlideToggleModule,
    AgrTableModule,
    AgrDialogModule,
    AgrFilterModule,
    RouterModule,
  ],
  providers: [
    ProductOverviewResolver,
    provideState('productModule', productReducer.reducer),
    provideEffects([ProductEffects]),
  ],
})
export class ProductModule {}
